export default __webpack_public_path__ + "static/media/gallery_01.06970c1b.jpg";